import { createEnv } from '@t3-oss/env-nextjs'
import { z } from 'zod'

export const env = createEnv({
  server: {
    // The API's loopback address on a preview box (`http://127.0.0.1:<api port>`).
    // Server-only: server-rendered requests use it so they never meet the team
    // gate in front of the public origin. Never expose it under a public name.
    BACKEND_INTERNAL_URL: z.url().optional()
  },
  client: {
    NEXT_PUBLIC_BACKEND_URL: z.string().min(1),
    NEXT_PUBLIC_APP_URL: z.string().default('https://app.schooljourney.com'),
    NEXT_PUBLIC_APP_ENV: z.enum(['local', 'development', 'staging', 'production']).default('production'),
    // `1` on a preview box: a per-feature copy of the product with test schools.
    NEXT_PUBLIC_PREVIEW_BOX: z.string().optional()
  },
  runtimeEnv: {
    BACKEND_INTERNAL_URL: process.env.BACKEND_INTERNAL_URL,
    NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
    NEXT_PUBLIC_BACKEND_URL: process.env.NEXT_PUBLIC_BACKEND_URL,
    NEXT_PUBLIC_APP_ENV: process.env.NEXT_PUBLIC_APP_ENV,
    NEXT_PUBLIC_PREVIEW_BOX: process.env.NEXT_PUBLIC_PREVIEW_BOX
  }
})
